import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { SendDownloadLinksFormDataProviderFactory } from '../factory/SendDownloadLinksFormDataProviderFactory';
import { SendDownloadLinksFormBaseDataProvider } from '../dataProvider/SendDownloadLinksFormBaseDataProvider';
import { SendDownloadLinksResponse } from '../../types/types';

export class SendDownloadLinksFormRepository extends BaseWebComponentRepository {
  public dataProviderFactory: SendDownloadLinksFormDataProviderFactory;
  public dataProvider: SendDownloadLinksFormBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new SendDownloadLinksFormDataProviderFactory(),
    });
  }

  public async sendDownloadLinksEmail(packageId: string, emails: Array<string>, ringId: string | number): Promise<SendDownloadLinksResponse> {
    return this.dataProvider.sendDownloadLinksEmail(packageId, emails, ringId);
  }

  public async getDataForView() {
    return {};
  }
}
